import { FileService } from '@galaxy-fe/utils';

export const fileService = new FileService({
    businessCode: '4001012',
    env: process.env.VUE_APP_ENV === 'production' ? 'prod' : 'test',
});
